import { render, staticRenderFns } from "./ExcelBridge.vue?vue&type=template&id=d4ce4b98&scoped=true&"
import script from "./ExcelBridge.vue?vue&type=script&lang=js&"
export * from "./ExcelBridge.vue?vue&type=script&lang=js&"
import style0 from "./ExcelBridge.vue?vue&type=style&index=0&id=d4ce4b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ce4b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
